import React, {
    useEffect,
    useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { coachingAPI } from 'api/coachingAPI';
import SearchIcon from 'assets/images/icon/SearchIcon';
import { cloneDeep } from 'lodash';
import { useNavigate } from 'react-router-dom';
import ReactSlider from 'react-slider';
import { useRecoilValue } from 'recoil';
import { userInfo } from 'state';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
    DropdownMenu,
    Overlay,
    Pagenation,
} from 'view/components';
import { CheckBox } from 'view/components/common/CheckBox';
import CreatePopup from 'view/pages/Coaching/components/CreatePopup';
import ListItem from 'view/pages/Coaching/components/ListItem';
import qs from "qs";
import TimeAwayPopup from "../components/TimeAwayPopup";
import InProgressList from "../components/InProgressList";
import SearchInputItem from "../../../components/common/SearchInputItem";

const categoryArr = [
    {
        dropdownItem:"Draft",
        display:"Draft",
        params:"DRAFT"
    },
    {
        dropdownItem:"Submitted",
        display:"Submitted",
        params:"IN_PROGRESS"
    },
    {
        dropdownItem:"Published",
        display:"Published",
        params:"PUBLISHED"
    },
]
const Published = (props) => {
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [timePopup, setTimePopup] = useState(false);
    const [coachingTitle, setCoachingTitle] = useState("")
    const [selectClass, setSelectClass] = useState(null);
    const [categoryParams, setCategoryParams] = useState(    {
        dropdownItem:"Draft",
        display:"Draft",
        params:"DRAFT"
    },);
    const [completed, setCompleted] = useState(true);
    const [received, setRceived] = useState(true);
    const [indexValue, setIndexValue] = useState({
        i: 0,
        v: 5,
    });
    const [pageInfo, setPageInfo] = useState({
        totalPages: 0,
        number: 0,
        size: 5,
    });
    const user = useRecoilValue(userInfo);

    const getClassItem = async () => {
        const result = await classesAPI
            .getClassList({
                //     unpaged:true,
                //    sort:{
                //     sorted:false
                //    },
            })
            .then((res) => {
                setClassList(cloneDeep(res?.content));
                return res?.content;
            });
        return result;
    };
    const getCoachingList = async () => {
        const result = await coachingAPI
            .getCoachingList({
                params: {
                    progress:"PUBLISHED",
                    // isReceived: received === true && completed === true ? "" : received,
                    // isCompleted: received === true && completed === true ? "" : !received,
                    // paged: true,
                    // page: pageNumber,
                    page: pageInfo?.number,
                    size: 5,
                },
            })
            .then((res) => {
                console.log("coa data", res);
                setList(cloneDeep(res?.data?.content));
                setPageInfo({
                    totalPages: res?.data?.totalPages,
                    number: res?.data?.number,
                    size: res?.data?.size,
                });
            });
    };

    const getClassItems = () => {
        const c = cloneDeep(classList);
        const arr = c
            ?.map((item) => {
                return {
                    ...item,
                    dropdownItem: item?.classTitle || "",
                };
            })
            .filter((filterItem) => {
                return filterItem?.progress === "PUBLISHED";
            });
        return arr || [];
    };

    const onClickDropdown = (item: any, key: string, index, obj) => {
        let selectItem;
        console.log("obj", obj);
        if (!isEmpty(obj)) {
            const copy = cloneDeep(obj);
            delete copy.dropdownItem;
            selectItem = copy;
        } else {
            selectItem = item;
        }
        console.log("selectItem", selectItem);
        setSelectClass(cloneDeep(selectItem));
    };

    const createCoaching = async () => {
        coachingAPI.createCoaching({
            params:{
                classesId:selectClass?.id,
                title:coachingTitle
            }
        })
            .then(res => {
                if(res?.success === true && !isEmpty(res?.data?.id)){
                    navigate("/create_coaching/details",{
                        state:{
                            createId:res?.data?.id
                        }
                    })
                }
            })
    };

    console.log('selectClass', selectClass)

    const onClickGetData = (item) => {
        setSelectedData(cloneDeep(item));

        props?.onClickPopup(true);
    };

    const onClickMovePage = (isNext) => {
        const c = cloneDeep(pageInfo);
        if (isNext) {
            if (pageInfo?.number + 1 === pageInfo?.totalPages) return;
            c.number = c.number + 1;
        } else {
            if (pageInfo?.number === 0) return;
            c.number = c.number - 1;
        }
        setPageInfo(c);
    };

    const onClickRemoveList = async (id) => {
        await coachingAPI.deleteCoachingItem(id)
            .then(res => {
                getCoachingList()
            })
    }

    const switchCategory = (text) => {
        switch (text){
            case "IN_PROGRESS" : {
                return "Submitted"
            }

            default:{
                return text
            }
        }
    }

    useEffect(() => {
        getCoachingList();
    }, [categoryParams, pageInfo.number]);

    // useEffect(() => {
    //     getCoachingList(pageInfo?.number);
    // }, [pageInfo.number]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [indexValue?.v]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [selectClass?.id]);

    useEffect(() => {
        getClassItem();
    }, []);

    console.log("getClassItems()", getClassItems());

    return (
        <Container>
            {props.popup && (
                <Overlay filter={true}>
                    <CreatePopup
                        classList={getClassItems()}
                        selectClass={selectClass}
                        onClickDropdown={onClickDropdown}
                        onChange={(e) => {
                            setCoachingTitle(e.target.value)
                        }}
                        value={coachingTitle}
                        onClick={() => {createCoaching()}}
                    />
                </Overlay>
            )}
            {
                timePopup &&
                <Overlay filter={true}>
                    <TimeAwayPopup data={selectedData}
                                   close={()=>{setTimePopup(v => !v)}}
                                   getList={()=>{
                                       getCoachingList();
                                   }} />
                </Overlay>
            }
            <ContentsInner>
                <SearchArea style={{ marginBottom: 15 }}>
                    <DropDownArea style={{width:"30%"}}>
                        {/*<DropDownWrap>*/}
                        {/*    <DropdownMenu*/}
                        {/*        selected={categoryParams?.display}*/}
                        {/*        altText="Select Category"*/}
                        {/*        borderColor={"#E5E5E5"}*/}
                        {/*        height={40}*/}
                        {/*        onClick={(...rest)=>{*/}
                        {/*            setCategoryParams(rest[3])*/}
                        {/*        }}*/}
                        {/*        items={categoryArr}*/}
                        {/*    />*/}
                        {/*</DropDownWrap>*/}
                        <DropDownWrap>
                            <DropdownMenu
                                selected={""}
                                altText="Newest"
                                borderColor={"#E5E5E5"}
                                height={40}
                                items={[]}
                            />
                        </DropDownWrap>
                    </DropDownArea>
                    <SearchInputItem/>
                </SearchArea>

                <Wrap>
                    {!isEmpty(list) &&
                        !isEmpty(user) &&
                        list?.map((item) => {
                            return (
                                <InProgressList
                                    userData={user}
                                    onClickPopup={onClickGetData}
                                    onClickIcon={onClickRemoveList}
                                    classTitle={item?.classesTitle}
                                    onClickGetList={()=>{
                                        getCoachingList();
                                    }}
                                    data={item?.coaching}
                                    onClickSelect={(item)=>{setSelectedData(item) }}
                                    onClickTimePopup={()=>{
                                        setTimePopup(v => !v)
                                    }}
                                />
                            );
                        })}
                </Wrap>
            </ContentsInner>
            <Pagenation
                totalPage={pageInfo?.totalPages}
                onClickMove={(isNext) => {
                    onClickMovePage(isNext);
                }}
                size={pageInfo?.size}
                pageNumber={pageInfo?.number}
            />
        </Container>
    );
};
export default Published;

const Container = styled.div`
    height: 100%;
    position: relative;
`;

const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
    position: relative;
    min-height: 550px;
    height: 100%;
`;
const Status = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
    }
`;

const StatusCheck = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    p {
        margin-right: 15px;
        font-weight: 700;
        color: "#333";
        font-size: 18px;
    }
`;
const SearchArea = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 30px;
`;
const DropDownArea = styled.div`
    display: flex;
    width: 50%;
`;

const DropDownWrap = styled.div`
    width: 100%;
    margin-right: 15px;
`;
const CheckItem = styled.div`
    span {
        margin-left: 5px;
        font-weight: 400;
        font-size: 18px;
    }
    margin-right: 15px;
    display: flex;
    align-items: center;
`;
const Slider = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    h5 {
        font-weight: 700;
        font-size: 18px;
        transform: translate(-20px, -7px);
    }
`;
const IndexItems = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 6px 0 6px;
    margin-top: 16px;
    span {
        text-align: center;
        display: flex;
        font-weight: 400;
        font-size: 14px;
        display: flex;
        justify-content: center;
    }
`;
const SliderWrap = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;

    .horizontal-slider {
        display: flex;
        align-items: center;

        .active {
            width: 16px;
            height: 16px;
            border: solid 1px red;
            background: red;
        }
        span {
            &:nth-child(1) {
                background: #fff;
            }
        }
        .mark {
            height: 16px;
            width: 16px;
            border-radius: 50%;
            background: #333;
            display: flex;
            align-items: center;
            justify-content: center;

            .indexItem {
                transform: translateY(10px);
            }
            &:first-of-type {
                background: #fff;
                border: solid 2px #333;
            }
            &:last-of-type {
                background: #fff;
                border: solid 2px #333;
            }
        }
        .track {
            height: 8px;
            border-radius: 6px;
            background: #3333331a;
        }
        .track-0 {
            background: #333333;
        }
        .thumb {
            border-radius: 50%;
            height: 16px;
            width: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #111;
        }
    }
`;
